import React from 'react';
import { Typography } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import { useLocation } from 'react-router';
import styles from "./ExpiredProposalPage.module.scss";
const ExpiredProposalPage = () => {
  const {
    state
  } = useLocation();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(AnchorLogo, {
    theme: "dark",
    "data-testid": "expired-proposal-page-logo",
    height: 64
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    weight: "normal",
    "data-testid": "expired-proposal-page-title"
  }, "This proposal has expired"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    "data-testid": "expired-proposal-page-subtitle",
    className: styles.subtitle
  }, "We're sorry, but the proposal you are trying to access has expired and is no longer available. Please\n            contact ".concat((state === null || state === void 0 ? void 0 : state.vendorName) || 'your business provider', " if you have any questions or require further assistance.")));
};
export default ExpiredProposalPage;